// api/WikiPermissionAPI.ts
import { registerQuery, registerSubscription } from "@adornis/baseql/metadata/register.js";
import { WikiPermission } from "../db/WikiPermission.js";
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { from } from "rxjs";
import { AdornisFilter } from "@adornis/filter/AdornisFilter.js";
var PERMISSIONS = {
  permissions: [],
  permissionTranslator: (permission) => permission
};
var wikiHasPermissions = registerQuery({
  type: () => Boolean,
  operationName: "wikiHasPermissions",
  resolve: () => {
    return async () => {
      return PERMISSIONS.permissions.length > 0;
    };
  },
  params: []
});
var wikiGetPermissions = registerQuery({
  type: () => [WikiPermission],
  operationName: "wikiGetPermissions",
  resolve: (search) => {
    return async (gqlFields) => {
      return PERMISSIONS.permissions.filter((f) => {
        if (!search || search.length === 0)
          return true;
        return f.toLowerCase().includes(search.toLowerCase()) || PERMISSIONS.permissionTranslator(f).toLowerCase().includes(search.toLowerCase());
      }).map((p) => {
        return new WikiPermission({
          id: p,
          name: PERMISSIONS.permissionTranslator(p)
        });
      });
    };
  },
  params: [{ type: () => String, name: "search" }]
});
var wikiSubscribePermissions = registerSubscription({
  type: () => [WikiPermission],
  operationName: "wikiSubscribePermissions",
  resolve: (skip, limit, filter) => {
    return (gqlFields) => {
      return from(
        new Promise(async (resolve) => {
          const permissions = await wikiGetPermissions(filter.search ?? "")(gqlFields);
          resolve(permissions.slice(skip, skip + limit));
        })
      );
    };
  },
  params: [
    { type: () => Int, name: "skip" },
    { type: () => Int, name: "limit" },
    { type: () => AdornisFilter, name: "filter" }
  ]
});
var WikiPermissionAPI;
((WikiPermissionAPI2) => {
  WikiPermissionAPI2.setPermissions = (permissions) => {
    PERMISSIONS.permissions = permissions;
  };
  WikiPermissionAPI2.setPermissionTranslator = (fn) => {
    PERMISSIONS.permissionTranslator = fn;
  };
  WikiPermissionAPI2.hasPermissions = wikiHasPermissions;
  WikiPermissionAPI2.getPermissions = wikiGetPermissions;
  WikiPermissionAPI2.subscribePermissions = wikiSubscribePermissions;
})(WikiPermissionAPI || (WikiPermissionAPI = {}));
export {
  WikiPermissionAPI,
  wikiGetPermissions,
  wikiHasPermissions,
  wikiSubscribePermissions
};
